import { Controller } from "react-hook-form";
import PercentageInputField from "../PercentageInputField/PercentageInputField";

const PercentageInputFieldV2 = ({
  onChange = () => {},
  name = "",
  control,
  ...props
}) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange: onControllerChange } }) => (
        <PercentageInputField
          name={name}
          onChange={(e) => {
            onControllerChange(e?.target?.value);
            onChange(e);
          }}
          {...props}
        />
      )}
    />
  );
};

export default PercentageInputFieldV2;
